// MINI
jQuery(document).ready(function(t){var e={TOTAL_ITEMS:".cart-total-items",TOTAL_PRICE:".cart-total-price",SUBMIT_ADD_TO_CART:"input[type=image], input.submit-add-to-cart",FORM_UPDATE_CART:"form[name=cartform]",FORM_UPDATE_CART_BUTTON:"form[name=cartform] input[name=update]",FORM_UPDATE_CART_BUTTONS:"input[type=image], input.button-update-cart",LINE_ITEM_ROW:".cart-line-item",LINE_ITEM_QUANTITY_PREFIX:"input#updates_",LINE_ITEM_PRICE_PREFIX:".cart-line-item-price-",LINE_ITEM_REMOVE:".remove a",EMPTY_CART_MESSAGE:"#empty"},a=function(t){return Shopify.formatMoney(t,"${{ amount }}")};

t(document).on("submit",'form[action*="/cart/add"]',function(e){
    e.preventDefault(),
    t(e.target).find(".btn-cart").attr("disabled",!0).addClass("disabled");
    
    var inputId;
    if(t(e.target).find('#product-select option').length>0) {
        inputId=parseInt(t(e.target).find('#product-select option')[0].value);
    } else if(t(e.target).find('input[name="id"]').length>0) {
        inputId=parseInt(t(e.target).find('input[name="id"]')[0].value);
    }

    var input=t(e.target).find('input[name="quantity"]');
    var inputQty=1;
    if(input.length>0) {
        inputQty = parseInt(input.value);
        if(!inputQty>0){inputQty=1}    
    }

    var maxCartQty=parseInt(input.max);
    if(!maxCartQty>0){maxCartQty=3}

    var curQty=0;
    jQuery.getJSON("/cart.js", function(a) {
        var curVariantInCart=a.items.filter(function(x) {return x.id == inputId});
        if(curVariantInCart.length>0) {
            curQty=curVariantInCart[0].quantity;
        }

        if(inputQty>maxCartQty || (inputQty + curQty)>maxCartQty) {
            Shopify.addItemFromFormBreak(maxCartQty)
        } else {
            Shopify.addItemFromForm(e.target)
        }
    })
}),

t(document).on("click",".btn-cart",function(){t.fancybox.showLoading(),t.fancybox.helpers.overlay.open({parent:t("body")})}),t(e.FORM_UPDATE_CART_BUTTON).click(function(a){a.preventDefault(),t(a.target.form).find(e.FORM_UPDATE_CART_BUTTONS).attr("disabled",!0).addClass("disabled"),Shopify.updateCartFromForm(a.target.form)}),t(e.FORM_UPDATE_CART).delegate(e.LINE_ITEM_REMOVE,"click",function(a){a.preventDefault();var i=this.href.split("/").pop().split("?").shift();Shopify.removeItem(i),t(this).parents(e.LINE_ITEM_ROW).remove()}),Shopify.onItemAdded=function(e,a){t(a).find(".btn-cart").attr("disabled",!1).removeClass("disabled"),Shopify.getCart()},Shopify.onCartUpdate=function(i,n){t("#cart_items").html(i.item_count);var r=a(i.total_price);t(e.TOTAL_PRICE).html(r),t(e.EMPTY_CART_MESSAGE).length>0&&0==i.item_count&&(t(e.FORM_UPDATE_CART).hide(),t(e.EMPTY_CART_MESSAGE).show()),n=n||!1,n&&i.item_count>0&&(t.each(i.items,function(i,n){t(e.LINE_ITEM_PRICE_PREFIX+n.id).html(a(n.line_price)),t(e.LINE_ITEM_QUANTITY_PREFIX+n.id).val(n.quantity)}),t(n).find("input[value=0]").parents(e.LINE_ITEM_ROW).remove(),t(n).find(e.FORM_UPDATE_CART_BUTTONS).attr("disabled",!1).removeClass("disabled"))},Shopify.onError=function(){t("form").find(".btn-cart").attr("disabled",!1).removeClass("disabled")}});